<template>
  <div class="super-container">
  <transition name="slide-fade">
    <div
      v-if="show"
      class="banner-container"
    >
      <div>
        <div>
          <img
            class="left-bubbles"
            :src="bubbles"
          >
        </div>
        <img
          class="user-icon"
          :src="userIcon"
        >
        <div class="share-text"> {{ $t("Descarga y comparte en redes tu puntaje, ") }} <br>
         <span class="emphasis"> {{ $t("justifica que eres un candidato confiable para contratar.") }}</span>
        </div>
        <div class="button-container">
          <button
            class="button"
            @click="share()"
          >
            <img
              class="share-icon"
              :src="shareIcon"
            >
            {{ $t("Compartir") }}
          </button>
          <a
            class="button"
            :href="image"
            download="truchecks.png"
          >
            <img
              class="download-icon"
              :src="downloadIcon"
            >
            {{ $t("Descargar") }}
          </a>
        </div>
        <div class="box">
          <img
            class="middle-right-bubbles"
            :src="bubbles"
          >
          <button
            class="close-button"
            @click="close()"
          >
            <img
              class="close-icon"
              :src="closeIcon"
            >
          </button>
          <img
            class="right-bubbles"
            :src="bubbles"
          >
        </div>
      </div>
    </div>
  </transition>
  <ShareModal key="modal" :dialog="showModal" :score="check.score" :image="image"/>
  </div>
</template>

<script>
import Vue from 'vue'
import domtoimage from 'dom-to-image'
import ShareModal from './ShareModal.vue'

export default Vue.extend({
  name: 'ShareBanner',
  components: {
    ShareModal
  },
  props: {
    check: {
      type: Object,
      default: () => {}
    },
    token: {
      type: String,
      required: true
    }
  },
  data: () => {
    return {
      shouldShow: false,
      shouldNotShowAgain: false,
      showModal: false,
      image: ''
    }
  },
  created () {
    window.addEventListener('scroll', this.handleScroll)
  },
  destroyed () {
    window.removeEventListener('scroll', this.handleScroll)
  },
  computed: {
    show () {
      const isGoodCandidate = 10 * this.check.score >= 8
      return !this.shouldNotShowAgain && this.shouldShow && this.check && this.check.status === 'completed' && isGoodCandidate
    },
    bubbles () {
      return require('@/assets/images/banner/orange_points.png')
    },
    userIcon () {
      return require('@/assets/icons/user_share.svg')
    },
    downloadIcon () {
      return require('@/assets/icons/download.svg')
    },
    shareIcon () {
      return require('@/assets/icons/share.svg')
    },
    closeIcon () {
      return require('@/assets/icons/close.svg')
    }
  },
  methods: {
    share () {
      // use partial pdf modal instead, as an alternative to share the image
      // this.showModal = true
      // this.shouldNotShowAgain = true

      location.href = `https://truchecks-premium.web.app/pdf/${this.check.check_id}/pdf-web/${this.token}?modalOpen=true`
    },
    setImage () {
      const capture = document.getElementById('summary')

      domtoimage
        .toPng(capture)
        .then((dataUrl) => {
          this.image = dataUrl
        })
        .catch((error) => {
          console.error('oops, something went wrong!', error)
        })
    },
    close () {
      this.shouldNotShowAgain = true
    },
    handleScroll () {
      this.shouldShow = true
      if (this.check.summary && this.check.summary.names_found && this.image === '') {
        this.setImage()
      }
    }
  }
})
</script>

<style lang="scss" scoped>
@import '@/styles/variables';
.super-container {
  overflow: hidden;
  position: sticky;
  bottom: 0;
  z-index: 10;
}

.banner-container {
  padding: 0;
  color: white;
  font-family: Poppins, sans-serif;
  font-size: 20px;
  background-color: #1E37F5;
  height: 108px;
}

.banner-container > div {
  display: flex;
  justify-content: space-between;
  height: 100%;
  align-items: center;
  padding: 0 16vw 0 8vw;
  position: relative;
}

.banner-container > div > div:first-child{
  position: absolute;
  left: 0;
}

.banner-container > div > div:nth-last-child(2){
  display: flex;
}

.banner-container > div > div:last-child {
  position: absolute;
  right: 0;
  width: 20vw;
}

.share-text {
  max-width: 40vw;
}

.emphasis {
  font-weight: 600;
}

.button {
  font-family: Poppins, sans-serif;
  font-size: 15px;
  font-weight: normal;
  font-stretch: normal;
  font-style: normal;
  line-height: normal;
  letter-spacing: normal;
  color: #1d262c;
  margin: 0 0 0 15px;
  padding: 10px 15px 9px 16px;
  border-radius: 7px;
  border: solid 1px #eff2f8;
  background-color: #ffffff;
  z-index: 1;
}

.right-bubbles,
.middle-right-bubbles {
  position: absolute;
}

.left-bubbles {
  margin-top: -30px;
  margin-left: -18px;
}

.box {
  display: flex;
  flex-direction: column;
}

.box .right-bubbles {
  align-self: flex-end;
  margin-top: -70px;
}

.box .middle-right-bubbles {
  align-self: start;
  margin-top: 50px;
}

.button {
  display: flex;
  align-items: center;
}

.button > img {
  padding-right: 0.5em;
}

.slide-fade-enter-active {
  transition: all .3s ease;
}
.slide-fade-leave-active {
  transition: all .4s cubic-bezier(1.0, 0.5, 0.8, 1.0);
}

.slide-fade-enter, .slide-fade-leave-to {
  transform: translateX(10px);
  opacity: 0;
}

.user-icon {
  padding-right: 32px!important;
  height: 71px;
}

.close-icon {
  width: 33px;
  height: 33px;
}

.share-icon {
  height: 19px;
}

.download-icon {
  height: 26px;
}

.question {
  padding-left: 10px!important;
}

@media screen and (max-width: $screen-breakpoint-sm) {
  .banner-container {
    height: auto;
    font-size: 14px;
  }

  .banner-container > div {
    flex-direction: column;
    padding: 0 16px;
  }

  .user-icon,
  .right-bubbles,
  .middle-right-bubbles,
  .left-bubbles {
    display: none;
  }

  .share-text {
    max-width: none;
    padding: 24px calc(20vw - 16px) 0 0;
    line-height: 25px;
    text-align: justify;
  }

  .button-container {
    padding: 24px 0;
    width: 100%;
    justify-content: space-between;
  }

  .button {
    margin: 0;
    width: 100%;
    justify-content: center;
  }

  a.button {
    margin-left: 16px;
  }

  .box {
    top: 24px;
  }
}
</style>
